export default "__VITE_PUBLIC_ASSET__f33aaf30__"